export const ADMIN_EMAILS = ['randolph@pokerand.net', 'andrew.shane@pokerand.net'];

export const STAFF_PERMISSION_DEFINITIONS = [
  { key: 'stream_performance', label: 'Stream Performance' },
  { key: 'card_shows', label: 'Card Shows' },
  { key: 'japan_cards', label: 'Japan Cards' },
  { key: 'slab_vault', label: 'Slab Vault' },
  { key: 'inventory_picking', label: 'Inventory Picking (no purchase costs)' },
  { key: 'inventory_safes', label: 'Safe operations and Browse Slabs (Joe / Gene)' },
  { key: 'cardrush', label: 'Cardrush' },
  { key: 'private_purchase', label: 'Private Purchase' },
  { key: 'stream_review', label: 'Stream Review' },
  { key: 'stream_intelligence', label: 'Stream Intelligence' },
  { key: 'sales_search', label: 'Sales Search' },
  { key: 'buylist_uploader', label: 'Buylist Uploader' },
  { key: 'sku_generator', label: 'SKU Generator' },
  { key: 'received_goods', label: 'Received Goods' },
  { key: 'cardcam_financials', label: 'CardCam Financials' },
];

export const DEFAULT_STAFF_PERMISSIONS = Object.freeze({
  stream_performance: false,
  card_shows: false,
  japan_cards: false,
  slab_vault: false,
  inventory_picking: false,
  inventory_safes: false,
  cardrush: false,
  private_purchase: false,
  stream_review: true,
  stream_intelligence: false,
  sales_search: false,
  buylist_uploader: false,
  sku_generator: false,
  received_goods: false,
  cardcam_financials: false,
});

export function normalizeEmail(email) {
  return String(email || '').toLowerCase().trim();
}

export function normalizePermissions(input, fallback = DEFAULT_STAFF_PERMISSIONS) {
  const source = input && typeof input === 'object' && !Array.isArray(input) ? input : {};
  const base = fallback && typeof fallback === 'object' && !Array.isArray(fallback)
    ? fallback
    : DEFAULT_STAFF_PERMISSIONS;

  return STAFF_PERMISSION_DEFINITIONS.reduce((acc, field) => {
    if (source[field.key] === undefined) {
      acc[field.key] = Boolean(base[field.key]);
      return acc;
    }

    acc[field.key] = Boolean(source[field.key]);
    return acc;
  }, {});
}

export function isAdminUser(user) {
  const role = String(user?.role || '').toLowerCase().trim();
  if (role === 'admin') return true;
  return ADMIN_EMAILS.includes(normalizeEmail(user?.email));
}

export function hasPermission(user, permissionKey) {
  if (isAdminUser(user)) return true;
  const permissions = normalizePermissions(user?.permissions);
  return Boolean(permissions[permissionKey]);
}
